import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAccountValue, getLastDividend, getCashAndIncome } from '../../services/PortfolioApi/portfolioApi';
import { toastNotify } from '../../utils/toastNotify';
const initialState = {
  loading: true,
  accountValue: {},
  lastDividendData: {},
  cashAndIncome: {},
  isUpdating: false,
};
export const fetchAccountValueDataAction = createAsyncThunk('FEATCH_ACCOUNT_VALUE_DATA', getAccountValue);
export const featchLastDividendAction = createAsyncThunk('FEATCH_LAST_DIVIDEND_DATA', getLastDividend);
export const featchCashAndIncomeAction = createAsyncThunk('FEATCH_CASH_AND_INCOME', getCashAndIncome);

export const portfolioSlice = createSlice({
  name: 'propertyDetails',
  initialState,
  extraReducers: {
    [fetchAccountValueDataAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchAccountValueDataAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        accountValue: action.payload,
      };
    },
    [fetchAccountValueDataAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        accountValue: {},
      };
    },

    [featchLastDividendAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [featchLastDividendAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        lastDividendData: action.payload,
      };
    },
    [featchLastDividendAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        lastDividendData: {},
      };
    },

    [featchCashAndIncomeAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [featchCashAndIncomeAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        cashAndIncome: action.payload,
      };
    },
    [featchCashAndIncomeAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        cashAndIncome: {},
      };
    },
  },
});

const { reducer } = portfolioSlice;
export default reducer;
